import React, {useEffect} from 'react';
import {createRoot} from 'react-dom/client';

import YoutubePlayer from '@Themes/natucare/modules/Article/components/YoutubePlayer/YoutubePlayer';

export const useYoutubeType = (ref => {
  useEffect(() => {
    if (ref.current) {
      const elements = ref.current.querySelectorAll('[data-type="youtube"]');

      [].slice.call(elements).forEach(el => {
        createRoot(el).render(<YoutubePlayer id={el.dataset.id} buttonLabel='odtwórz video'
                                             alt='Kliknij, by odtworzyć'/>);
      });
    }
  }, []);
});
